import { Component } from 'react';
import Button from '@mui/material/Button';
import classnames from 'classnames';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { WithStyles, withStyles } from '@mui/styles';
import APCurrencyIcon from '../APCurrencyIcon';
import APDropDownMenuStyles from './styles/APDropDownMenu.style';
import { ReactComponent as DownArrowIcon } from "./assets/icons/icon-chevron-down.svg";
import { ReactComponent as DownloadIcon } from "./assets/icons/icon-download.svg";

interface APDropDownMenuProps extends WithStyles<typeof APDropDownMenuStyles> {
	className: string,
	label: string,
	onChange: Function,
	options: any,
	isFlag?: boolean,
	hasDownloadIcon?: boolean,
	disabled?: boolean
}

class APDropDownMenu extends Component<APDropDownMenuProps, {}> {

	state = {
		anchor: null,
		open: false,
		flag: ''
	};

	constructor(props: APDropDownMenuProps) {
		super(props);

		this.onClose = this.onClose.bind(this);
		this.onOpen = this.onOpen.bind(this);
	}

	onClose(evt: any) {
		const {
			target: {
				id
			}
		} = evt;

		this.setState({
			open: false
		}, () => {
			if (id && this.props.onChange) {
				this.props.onChange(id);
				this.setState({
					flag: id
				})
			}
		});
	}

	onOpen(evt: any) {
		this.setState({
			anchor: evt.currentTarget,
			open: true
		});
	}

	componentDidMount() {
		this.setState({
			flag: this.props.label
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.label !== this.props.label) {
			this.setState({
				flag: this.props.label
			});
		}
	}

	render() {
		const {
			classes,
			className,
			label,
			options,
			isFlag,
			hasDownloadIcon,
			disabled
		} = this.props;

		const containerCls = classnames(className, classes.dropDownMenuContainer);

		let buttonlabel;
		if (hasDownloadIcon) {
			buttonlabel = (<>
				<DownloadIcon className={classes.downloadIcon} />
				{ label}
				<DownArrowIcon className={classes.arrowIcon} />
			</>);
		} else {
			buttonlabel = (<>
				{label}
				<DownArrowIcon />
			</>);
		}
		return (
			<div className={containerCls}>
				<Button data-testid='dropdown-button' disabled={disabled} color="primary" onClick={this.onOpen} disableRipple={true}>
					{isFlag && <APCurrencyIcon currency={this.state.flag} />}
					{buttonlabel}
				</Button>
				<Menu className={classes.list} anchorEl={this.state.anchor} open={this.state.open} onClose={this.onClose}
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
					transformOrigin={{ vertical: "top", horizontal: "right" }}>
					{options.map((option: any,index) => (
						<MenuItem className={classes.item} onClick={this.onClose} id={option.value} key={`key-${index}`}>
							{isFlag && <APCurrencyIcon currency={option.value} />} {option.label}
						</MenuItem>
					))}
				</Menu>
			</div>
		);
	}
}

export default withStyles(APDropDownMenuStyles)(
	APDropDownMenu
);
